// HHT1 애니메이션, HHT2 시트콤 영상 video id
const videoIdMap = {
  "hht1": {
    "01": "bf3722117f18a4db75174d24eab04004",
    "02": "9d212b397d2450d83485b6c4f68ef284",
    "03": "ae4af3bdcf572d551bc056b9180a63c6",
    "04": "cd493b8b08bf1863e2466286979680b6",
    "05": "2975e00c33c39e95e7aa3e209571884a",
    "06": "63e48aebc7dcd3144d0a3c54b9a00a4d",
    "07": "57139d7510bc5c0624dde0b3e9944e55",
    "08": "46e3c7604a24c745c2d2f4a358ecc34e",
    "09": "afd4ddd7e34eae96af02b1c438e8b251",
    "10": "d3b82f8d0c93774a1dd342a3dc9a1835",
    "11": "4684553e7cb04ef5228f68f1b5bfc220",
    "12": "07299e0b9721822996baf47b61e32a74",
    "13": "25c4e95185afead830529e6c71f6d23f",
    "14": "86c5c94095df892c58ea9fa87d78c5e3",
    "15": "a3071a751722c7f7ce4e5a32df3e3a1d",
    "16": "f7eeb475f00c32cc95ba728de28e4a6b",
    "17": "93da977f2d3e265c2b5bb563d3b52bca",
    "18": "fddb8c5aaba050e07be323276d69538d",
    "19": "0f67b8b7ead336b718f296d6b35fe267",
    "20": "0d14c36e2f5ba36840f261bb901347a0"
  },
  "hht2": {
    "01": "3bc1fbc14fcbc84847037f66bc984557",
    "02": "70477fb218f61abc039bed612a82a13e",
    "03": "af11badc3709f8849b7c5a81f4b2232c",
    "04": "91792c179e85fd7caeac83e5866c85fc",
    "05": "659d23e0172d31f0ca4d6504612fc14b",
    "06": "2fad6bf86d8648e4b8b8a871d883415a",
    "07": "3d96dd035bce8c907237027587d214c4",
    "08": "a2728d597a73624cede7a9e6ce247a60",
    "09": "65660926294da26031ca700eaedc59be",
    "10": "3e8f67bee49b4aa0fcba0a68f0e85c11",
    "11": "364b9140c82455f582571b699f9cca99",
    "12": "6cd1fe0ed93b7384c43b6e3fdc35b37a",
    "13": "efa2834b56e03d3f6d9a782536b012d5",
    "14": "2bf8f36591881f01adf45b1e49b5f542",
    "15": "c1ddb646ece142a07353abc04b36f1fd",
    "16": "bb037aaf5b477db15e44495a72af7b98",
    "17": "b8f0d21a04d5ef3d8bbbffdafc149558",
    "18": "a85d55c4dedf27f119714de5cbd2dd02",
    "19": "b69074799f29cf82c35ce50acc18d0a8",
    "20": "a9cd10fade91a3fc12af829ae256bb04"
  }
}

export default videoIdMap;